import { Controller } from '@hotwired/stimulus'

// Triggers a POST to the configured Slack-test endpoint from the settings page
// (the webhook is already stored in Settings DB or ENV, so we don't pass it
// through the request body). Renders the outcome inline next to the button.
//
// Usage:
//   data-controller="slack-settings-test"
//   data-slack-settings-test-url-value="<%= api_slack_test_path %>"
//
//   <button data-slack-settings-test-target="button" data-action="slack-settings-test#test">Tester</button>
//   <span data-slack-settings-test-target="result"></span>
export default class extends Controller {
  static targets = ['input', 'button', 'result']
  static values = { url: String }

  async test() {
    this.#disableButton()
    this.#setResult('Envoi…', 'pending')

    try {
      const response = await fetch(this.urlValue, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'X-CSRF-Token': this.#csrfToken()
        },
        body: this.#bodyPayload()
      })
      const data = await response.json()

      if (data.ok) {
        this.#setResult('\u2713 Message envoyé sur Slack !', 'ok')
      } else {
        this.#setResult(`\u2717 ${data.error || 'Échec'}`, 'error')
      }
    } catch (error) {
      this.#setResult(`\u2717 ${error.message}`, 'error')
    } finally {
      this.#enableButton()
    }
  }

  #bodyPayload() {
    const typed = this.hasInputTarget ? this.inputTarget.value.trim() : ''
    return `slack_webhook_url=${encodeURIComponent(typed)}`
  }

  #setResult(text, kind) {
    if (!this.hasResultTarget) return

    this.resultTarget.textContent = text
    this.resultTarget.dataset.kind = kind
  }

  #disableButton() {
    if (this.hasButtonTarget) this.buttonTarget.disabled = true
  }

  #enableButton() {
    if (this.hasButtonTarget) this.buttonTarget.disabled = false
  }

  #csrfToken() {
    return document.querySelector('meta[name="csrf-token"]')?.content
  }
}
